import React, { useState, useEffect } from "react";
import { projects } from "../../utils";
import ProjectCard from "./ProjectCard";
import "./projects.css";

const Projects = () => {
  const [dots, setDots] = useState([]);

  useEffect(() => {
    // Generate random dots
    const newDots = [];
    for (let i = 0; i < 30; i++) {
      newDots.push({
        id: i,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 4}s`,
        duration: `${3 + Math.random() * 2}s`,
      });
    }
    setDots(newDots);
  }, []);

  return (
    <div className="projects_container">
      {/* Background elements */}
      <div className="projects-background">
        {/* Hexagon grid */}
        <div className="hexagon-grid"></div>

        {/* Geometric shapes */}
        <div className="geometric-container">
          <div className="geometric-shape shape-1"></div>
          <div className="geometric-shape shape-2"></div>
          <div className="geometric-shape shape-3"></div>
        </div>

        {/* Animated dots */}
        <div className="dots-container">
          {dots.map((dot) => (
            <div
              key={dot.id}
              className="dot"
              style={{
                top: dot.top,
                left: dot.left,
                animationDelay: dot.delay,
                animationDuration: dot.duration,
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="max-width">
        <h2 className="title">Other Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
